import { render, staticRenderFns } from "./TermosPage.vue?vue&type=template&id=5381dc76&scoped=true"
import script from "./TermosPage.vue?vue&type=script&lang=js"
export * from "./TermosPage.vue?vue&type=script&lang=js"
import style0 from "./TermosPage.vue?vue&type=style&index=0&id=5381dc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381dc76",
  null
  
)

export default component.exports